export const LogEvents = {
    FormSubmitError: (errorsByType, errors) =>
        `Error: ${JSON.stringify(
            errorsByType
        )} | Formik error: ${JSON.stringify(errors)}`,

    SubmitFlowError: errorType =>
        `an error occured while trying to submit the Flow ${errorType}`,

    FetchFlowError: errorType =>
        `an error occured while trying to fetch the Flow ${errorType}`,

    SignatureSign: (connected_variable_id, block_id) =>
        `Signature is signed | variable id: ${connected_variable_id} | block id: ${block_id}`,

    PageSubmitted: (order, pageId) =>
        `page with order: ${order} and id: ${pageId} was submitted`,

    LastPageSubmitted: 'The last page has been submitted',
    PaymentPaid: paymentId => `payment paid ${paymentId}`,

    UserBrandingDataNotFound: placementId =>
        `User branding data was not loaded to s3. PlacementId: ${placementId}`
};
